import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const ProductSelectionQuickViewLoading: React.FC<{
  className?: string;
}> = ({className}) => {
  return (
    <section className={className}>
      <SkeletonBlock
        $width="100%"
        $height="75px"
        disableSpaceBelow
        disableRoundedCorners
      />
    </section>
  );
};
